import { saasModernTheme } from 'common/theme/saasModern';
import styled from 'styled-components';

export const Hero2Section = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  }
`;

export const ContainerStyled = styled.div`
    display: flex;
    flex-direction: row; /* Default to row layout */
    gap: 20px; /* Gap between elements */
    align-items: center; /* Align items vertically */
    width:100%;
    @media (max-width: 1024px) {
      flex-direction: column-reverse; /* Reverse order on small screens */
    }
`;

export const Element1Styled = styled.div`
    flex: 0 0 60%;  
    @media (max-width: 1024px) {
      text-align: center;
    }
`;

export const Element2Styled = styled.div`
    flex: 0 0 40%;  
    @media (max-width: 680px) {
      flex: 0;  
    }
`;
